"use client";

import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase/client";

/** Ключ кэша TanStack Query для данных профиля текущего пользователя. */
export const profileQueryKey = ["profile"];

/** Текущий пользователь (auth) + строка `profiles` для его `id`. */
export function useProfile() {
  return useQuery({
    queryKey: profileQueryKey,
    queryFn: async () => {
      const {
        data: { user },
        error: authError,
      } = await supabase.auth.getUser();

      if (authError) {
        throw authError;
      }

      if (!user) {
        return { user: null, profile: null };
      }

      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", user.id)
        .maybeSingle();

      if (profileError) {
        throw profileError;
      }

      return { user, profile: profile ?? null };
    },
  });
}
